export const fromArrayToCSV = (array: string[] | undefined) => {
  if (!array || array.length === 0) return undefined;
  return array.join(',');
};
